define('view/dashboard.page',['require','exports','module','fukit','blockit','fukit','backbone.radio','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var AuthorizationBehavior         = require('fukit').AuthorizationBehavior,
      BlocKit                       = require('blockit'),
      ROLES                         = require('fukit').Roles,
      Radio                         = require('backbone.radio'),
      _                             = require('underscore'),
      UIKit                         = require('uikit/uikit');

  var coiModel;
  var productNewCoiUiValue = false;
  const enabledProductCollection = Radio.request('AppKit.resourceService', 'resource', 'enabledProductCollection');

  if (!localStorage.getItem('productNewCoiUi')) {
    if (!_.isUndefined(enabledProductCollection)) {
      coiModel = enabledProductCollection.findWhere({ name: 'COI', active: true });
      const dataModel = coiModel.collection.models;
      const filteredDataArray = dataModel.filter(function(item) {
        return item.attributes.name === 'COI' && item.attributes.active === true;
      });
      productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
    }

    if (productNewCoiUiValue) {
      localStorage.setItem('productNewCoiUiValue', productNewCoiUiValue.toString());
      location.assign(location.origin + '/coi-react/disclosure/list');
    }
  }

  console.log("productNewCoiUiValue dashboard", productNewCoiUiValue)

  var DashboardPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.FullWidthLayoutView,
        contentColumn: {
          components: [
            {
              type: BlocKit.AttachedComponentsContainerView,
              components: [
                {
                  type: BlocKit.ContentActionsHeaderView.extend({
                    className: BlocKit.ContentActionsHeaderView.prototype.className + ' dashboard',
                  }),
                  header: {
                    text: 'Disclosures Assigned to Me',
                    size: 'tiny',
                  },
                  actions: {
                    components: [
                      {
                        type: UIKit.Button,
                        size: 'tiny',
                        behaviors: {
                          NavigateOnEventBehavior: {
                            routeName: 'disclosureAssignedToMe:list',
                            model: '@resources.userPrincipalModel',
                            routeParams: { disclosureReviewerUserId: '@model.id' },
                            behaviorClass: BlocKit.NavigateOnEventBehavior,
                          },
                          BindAndFormatOptionValuesBehavior: {
                            optionValues: {
                              text: {
                                model: '@resources.disclosuresAssignedToMeCollection',
                                formatter: function(disclosuresAssignedToMeCollection) {
                                  var numberOfDisclosures =
                                    disclosuresAssignedToMeCollection.paginate.get('totalElements') || 0;
                                  return 'View All (' + numberOfDisclosures + ')';
                                },
                              },
                            },
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                          },
                        },
                      },
                    ],
                  },
                },
                {
                  type: UIKit.ComponentsContainerView,
                  className: 'dashboard table container',
                  components: [
                    {
                      type: BlocKit.BasicTableView.extend({
                        className: BlocKit.BasicTableView.prototype.className + ' dashboard',
                      }),
                      collection: '@resources.disclosuresAssignedToMeCollection',
                      columns: [
                        {
                          text: 'Disclosure Name',
                          formatter: BlocKit.Formatter.empty(),
                          behaviors: {
                            ResolveRouteBehavior: {
                              route: 'disclosure:form',
                              params: { primaryId: '@model.id' },
                              behaviorClass: BlocKit.ResolveRouteBehavior,
                            },
                          },
                          childView: UIKit.Text,
                          childViewOptions: {
                            color: 'primary',
                            underline: true,
                            bindings: {
                              text: 'name',
                            },
                            formatter: function(item) {
                              if (item && item.length > 50) {
                                item = item.slice(0, 50) + '...';
                              }
                              return item;
                            },
                          },
                        },
                        { text: 'Disclosee', data: 'disclosureOwnerName', formatter: BlocKit.Formatter.empty() },
                        { text: 'Type', data: 'templateTypeDescription', formatter: BlocKit.Formatter.empty() },
                        {
                          text: 'Date Assigned',
                          data: 'reviewerAssignedDate',
                          formatter: BlocKit.Formatter.date('L LT'),
                        },
                      ],
                      focusable: false,
                      emptyText: 'No disclosures.',
                    },
                  ],
                },
              ],
              behaviors: {
                AuthorizationBehavior: {
                  visibleOnlyWhen: [
                    {
                      roles: [ROLES.DISCLOSURE_READ_ALL],
                    },
                  ],
                  behaviorClass: AuthorizationBehavior,
                },
              },
            },
            {
              type: BlocKit.AttachedComponentsContainerView,
              components: [
                {
                  type: BlocKit.ContentActionsHeaderView.extend({
                    className: BlocKit.ContentActionsHeaderView.prototype.className + ' dashboard',
                  }),
                  header: {
                    text: 'No Reviewer Assigned',
                    size: 'tiny',
                  },
                  actions: {
                    components: [
                      {
                        type: UIKit.Button,
                        size: 'tiny',
                        behaviors: {
                          NavigateOnEventBehavior: {
                            routeName: 'disclosure:list',
                            routeParams: { disclosureStatus: 'Under Pre-Review' },
                            behaviorClass: BlocKit.NavigateOnEventBehavior,
                          },
                          BindAndFormatOptionValuesBehavior: {
                            optionValues: {
                              text: {
                                model: '@resources.disclosuresNotAssignedToReviewerCollection',
                                formatter: function(disclosuresNotAssignedToReviewerCollection) {
                                  var numberOfDisclosures = disclosuresNotAssignedToReviewerCollection.paginate.get(
                                    'totalElements'
                                  );
                                  return 'View All (' + numberOfDisclosures + ')';
                                },
                              },
                            },
                            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                          },
                        },
                      },
                    ],
                  },
                },
                {
                  type: UIKit.ComponentsContainerView,
                  className: 'dashboard table container',
                  components: [
                    {
                      type: BlocKit.BasicTableView.extend({
                        className: BlocKit.BasicTableView.prototype.className + ' dashboard',
                      }),
                      collection: '@resources.disclosuresNotAssignedToReviewerCollection',
                      columns: [
                        {
                          text: 'Disclosure Name',
                          formatter: BlocKit.Formatter.empty(),
                          behaviors: {
                            ResolveRouteBehavior: {
                              route: 'disclosure:form',
                              params: { primaryId: '@model.id' },
                              behaviorClass: BlocKit.ResolveRouteBehavior,
                            },
                          },
                          childView: UIKit.Text,
                          childViewOptions: {
                            color: 'primary',
                            underline: true,
                            bindings: {
                              text: 'name',
                            },
                            formatter: function(item) {
                              if (item && item.length > 50) {
                                item = item.slice(0, 50) + '...';
                              }
                              return item;
                            },
                          },
                        },
                        { text: 'Disclosee', data: 'disclosureOwnerName', formatter: BlocKit.Formatter.empty() },
                        { text: 'Type', data: 'templateTypeDescription', formatter: BlocKit.Formatter.empty() },
                        { text: 'Submission Date', data: 'submitDate', formatter: BlocKit.Formatter.date('L LT') },
                      ],
                      focusable: false,
                      emptyText: 'No disclosures.',
                    },
                  ],
                },
              ],
              behaviors: {
                AuthorizationBehavior: {
                  visibleOnlyWhen: [
                    {
                      // Only COI Admin has this role and reviewer doesn't
                      roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
                    },
                  ],
                  behaviorClass: AuthorizationBehavior,
                },
              },
            },
          ],
        },
      },
    },
  });

  module.exports = DashboardPageView;
});

